import i18n from '@/i18n'; /*
 * @Author: TigerLord
 * @Date: 2022-09-23 16:36:39
 * @LastEditTime: 2022-10-12 14:49:46
 * @LastEditors: your name
 * @Description: 功能说明：——
 * @FilePath: /ytzx-console/src/pages/company/AssociationSet/index.ts
 */
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('AssociationSet-index-1992f2b6ee25d2fe8-1'),
    routerUrl: '/AssociationSet',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./AssociationSet')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('AssociationSet-index-1992f2b6ee25d2fe8-2'),
        routerUrl: '/AssociationSetForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./AssociationSetForm')),
      },
      //$MORE$
    ],
  },
];
